import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./UniversitySemesterTable.css";

const UniversitySemesterTable = () => {
  const navigate = useNavigate();

  const [getSemesters, setGetSemesters] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/semesters`)
      .then((response) => {
        const semesters = response.data?.data || [];
        setGetSemesters(semesters);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleAddSemester = () => {
    navigate("/college-semester");
  };

  const handleAllSemester = () => {
    navigate("/college-semester-table");
  };

  const handleEdit = (id) => {
    navigate(`/university-edit-semester/${id}`);
  };
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this semester?")) {
      axios
        .delete(`${API_BASE_URL}/semesters/${id}`)
        .then(() => {
          alert("Semester deleted successfully!");
          setGetSemesters(
            getSemesters.filter((semester) => semester._id !== id)
          );
        })
        .catch((error) => console.log(error));
    }
  };

  return (
    <>
      <div id="college-all-course-inner-main-wrapper">
        <div className="course-header-with-btns-table-page">
          <h5>Semester/Year</h5>

          <div className="college-all-course-nav-btns-table">
            <Link to={"/college-semester"}>
              <button
                className="college-add-course-add-btn-table-page"
                onClick={handleAddSemester}
              >
                + Add New Semester/Year
              </button>
            </Link>
            <Link to={"/college-semester-table"}>
              <button
                className="college-all-course-btn-table-page"
                onClick={handleAllSemester}
              >
                All Semester/Year
              </button>
            </Link>
          </div>
        </div>

        {/* table */}
        <div className="headertable">
          <h5>All Semester/Year</h5>
          <table>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>semester</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {getSemesters.map((data, idx) => (
                <tr>
                  <td>{idx + 1}</td>
                  <td>{data.semesterName}</td>
                  <td>
                    <i
                      class="fa-solid fa-file-pen"
                      onClick={() => handleEdit(data._id)}
                    ></i>
                    <i
                      class="fa-solid fa-trash-can"
                      onClick={() => handleDelete(data._id)}
                    ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* headertable  */}
      </div>
      {/* college-all-course-inner-main-wrapper  */}
    </>
  );
};

export default UniversitySemesterTable;
